import React from 'react';
import { useTranslation } from '@shared/core';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import { useHeroTextByScenario } from '@apps/acquisitionFunnels/createWedding/hooks/useHeroTextByScenario';

const WeddingHeroText = () => {
  const { tq } = useTranslation('createWedding');
  const { createWeddingHeroText } = useHeroTextByScenario();

  return (
    <SpacingStack spacing={1}>
      <TextV2
        textAlign="center"
        typographyVariant="hed6"
      >
        {createWeddingHeroText}
      </TextV2>
      <TextV2
        textAlign="center"
        typographyVariant="body3"
        color="mono12"
      >
        {tq`We'll need a few details first.`}
      </TextV2>
    </SpacingStack>
  );
};

export default WeddingHeroText;
